export default "__VITE_ASSET__CnKkssST__"